import { MessageCircle, Phone } from "lucide-react";

export const WHATSAPP_URL = "https://wa.me/918090162185";
export const CALL_URL = "tel:+919236711383";
export const PHONE_DISPLAY = "+91 92367 11383";
export const GMB_URL = "https://maps.app.goo.gl/itAic6hYvoBS19P77";

export const ContactButtons = ({ idPrefix, compact = false }) => (
  <div className={`flex flex-wrap items-center gap-4 ${compact ? "" : "gap-5"}`}>
    <a
      data-testid={`${idPrefix}-whatsapp-cta`}
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="group inline-flex items-center gap-3 rounded-full bg-[#C5A059] px-7 py-3.5 text-sm font-semibold tracking-wide text-[#080809] shadow-[0_8px_32px_rgba(197,160,89,0.25)] transition-[transform,background-color,box-shadow] duration-500 hover:-translate-y-1 hover:bg-[#D4AF37] hover:shadow-[0_12px_40px_rgba(197,160,89,0.4)]"
    >
      <MessageCircle className="h-4 w-4 transition-transform duration-500 group-hover:rotate-6" />
      WhatsApp Us
    </a>
    <a
      data-testid={`${idPrefix}-call-cta`}
      href={CALL_URL}
      className="inline-flex items-center gap-3 rounded-full border border-[#C5A059]/40 px-7 py-3.5 text-sm font-semibold tracking-wide text-[#F5F5F0] transition-[transform,border-color,background-color] duration-500 hover:-translate-y-1 hover:border-[#C5A059] hover:bg-[#C5A059]/10"
    >
      <Phone className="h-4 w-4 text-[#C5A059]" />
      Call the House
    </a>
  </div>
);
